// Deployment configuration - injected at build time
export const DEPLOYMENT_CONFIG = {
  type: 'singleapp-public',
  defaultApp: 'shah',
  apiUrl: 'https://4fxda1yric.execute-api.us-east-1.amazonaws.com/prod'
};
